module.exports = __webpack_public_path__ + "img/ep-coeur-festonne.a5de52d8.jpg";